var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1751_703)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4545 0C15.8885 0 16.3048 0.172402 16.6116 0.47928C16.9185 0.786158 17.0909 1.20237 17.0909 1.63636V11.4545C17.0909 11.8885 16.9185 12.3048 16.6116 12.6116C16.3048 12.9185 15.8885 13.0909 15.4545 13.0909H5.63636C5.20237 13.0909 4.78616 12.9185 4.47928 12.6116C4.1724 12.3048 4 11.8885 4 11.4545C4 11.0206 4.1724 10.6043 4.47928 10.2975C4.78616 9.99058 5.20237 9.81818 5.63636 9.81818H13.8182V1.63636C13.8182 1.20237 13.9906 0.786158 14.2975 0.47928C14.6043 0.172402 15.0206 0 15.4545 0ZM28.5455 0C28.9794 0 29.3957 0.172402 29.7025 0.47928C30.0094 0.786158 30.1818 1.20237 30.1818 1.63636V9.81818H38.3636C38.7976 9.81818 39.2138 9.99058 39.5207 10.2975C39.8276 10.6043 40 11.0206 40 11.4545C40 11.8885 39.8276 12.3048 39.5207 12.6116C39.2138 12.9185 38.7976 13.0909 38.3636 13.0909H28.5455C28.1115 13.0909 27.6952 12.9185 27.3884 12.6116C27.0815 12.3048 26.9091 11.8885 26.9091 11.4545V1.63636C26.9091 1.20237 27.0815 0.786158 27.3884 0.47928C27.6952 0.172402 28.1115 0 28.5455 0ZM4 24.5455C4 24.1115 4.1724 23.6952 4.47928 23.3884C4.78616 23.0815 5.20237 22.9091 5.63636 22.9091H15.4545C15.8885 22.9091 16.3048 23.0815 16.6116 23.3884C16.9185 23.6952 17.0909 24.1115 17.0909 24.5455V34.3636C17.0909 34.7976 16.9185 35.2138 16.6116 35.5207C16.3048 35.8276 15.8885 36 15.4545 36C15.0206 36 14.6043 35.8276 14.2975 35.5207C13.9906 35.2138 13.8182 34.7976 13.8182 34.3636V26.1818H5.63636C5.20237 26.1818 4.78616 26.0094 4.47928 25.7025C4.1724 25.3957 4 24.9794 4 24.5455ZM26.9091 24.5455C26.9091 24.1115 27.0815 23.6952 27.3884 23.3884C27.6952 23.0815 28.1115 22.9091 28.5455 22.9091H38.3636C38.7976 22.9091 39.2138 23.0815 39.5207 23.3884C39.8276 23.6952 40 24.1115 40 24.5455C40 24.9794 39.8276 25.3957 39.5207 25.7025C39.2138 26.0094 38.7976 26.1818 38.3636 26.1818H30.1818V34.3636C30.1818 34.7976 30.0094 35.2138 29.7025 35.5207C29.3957 35.8276 28.9794 36 28.5455 36C28.1115 36 27.6952 35.8276 27.3884 35.5207C27.0815 35.2138 26.9091 34.7976 26.9091 34.3636V24.5455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1751_703",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1751_703"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1751_703",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRevert);
export default __webpack_public_path__ + "static/media/expand_revert.5dd60d1005a1f003fef898af07590b96.svg";
export { ForwardRef as ReactComponent };